import request from '@/utils/request'
export const queryPage = '/icps/system/sign/basics/plan/foreign_page'
/*根据供应商id获取车辆列表*/
export function cat_list(params) {
  return request({
    url: '/icps/system/sign/basics/plan/car/cat_list',
    method: 'get',
    params
  })
}
/*根据供应商id获取车辆列表*/
export function plan_car(params) {
  return request({
    url: '/icps/system/sign/basics/plan/car/plan_car',
    method: 'get',
    params
  })
}
/*根据供应商id获取车辆列表*/
export function saveOrupdate(params) {
  return request({
    url: '/icps/system/sign/basics/plan/car/batch_save_or_update',
    method: 'get',
    params
  })
}